<template>
    <div class="form-inline">
        <ol>
            <li v-for="(recip, i) in recipients" class="mb-2">
                <a href="javascript:void(0)" class="text-danger btn-link" v-on:click="deleteRecipient(i);"><i class="fa fa-trash"></i></a>

                <b-form-select class="form-control" v-model="recip.target_type" :options="recipientOptions" />

                <span v-if="recip.target_type != 'Supervisor' && recip.target_type != 'Violator'">=</span>

                <span v-if="recip.target_type == 'Employee'" class="d-lg-inline-block" style="width: 350px;">
                    <employee-select
                        :selectedValues="recip.target_label ? {EmployeeId: recip.target_label.EmployeeId, FirstName: recip.target_label.FirstName, LastName: recip.target_label.LastName, EmployeeNumber: recip.target_label.EmployeeNumber} : null"
                        @vselected="function(employee){ recip.target_value = employee.EmployeeId; }"
                        :hasError="errors['recipients['+i+']'] ? true : false" />
                </span>

                <template v-if="recip.target_type == 'Employee Title'">
                    <!-- <input type="text" v-model="recip.target_value" placeholder="Enter an Employee Title/Position" class="form-control" /> -->
                    <b-form-select v-model="recip.target_value" :options="titleOptions" :class="{'is-invalid': errors['recipients['+i+']']}" />
                </template>

                <template v-if="recip.target_type == 'Email'">
                    <input type="text" v-model="recip.target_value" placeholder="Enter an Email Address" class="form-control" />
                </template>

                <template v-if="recip.target_type == 'Role'">
                    <b-form-select class="form-control" v-model="recip.target_value" :options="roleOptions" />
                </template>

                <span v-if="recip.target_type == 'User'" class="d-lg-inline-block" style="width: 350px;">
                    <user-select
                        :selectedValues="recip.target_label ? {UserId: recip.target_label.UserId, FirstName: recip.target_label.FirstName, LastName: recip.target_label.LastName} : null"
                        @vuselected="function(user){ recip.target_value = user.UserId; }"
                        :hasError="errors['recipients['+i+']'] ? true : false" />
                </span>

                <span v-if="errors['recipients['+i+']']" class="text-danger">
                    <br>
                    <span v-for="(error, key) in errors['recipients['+i+']']"><template v-if="key > 0">, </template>{{ error }}</span>
                </span>
            </li>
        </ol>
    </div>
</template>

<script>
    export default {
        props: {
            startingRecipients: {
                type: Array,
                default: () => [],
            },

            assetType: {
                type: String,
                default: null
            },
        },

        data() {
            return {
                errors: {},
                recipients: [],
                recipientTypes: [],
                titles: [],
                roles: [],
            }
        },

        computed: {

            recipientOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Target Type --'}
                ];

                //Loop
                for(var i = 0; i < this.recipientTypes.length; i++)
                {
                    //Push
                    options.push({value: this.recipientTypes[i], text: this.recipientTypes[i]});
                }

                //Send it
                return options;
            },

            roleOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Role --'}
                ];

                //Loop
                for(var i = 0; i < this.roles.length; i++)
                {
                    //Push
                    options.push({value: this.roles[i].id, text: this.roles[i].name});
                }

                //Send it
                return options;
            },

            logicOptions(){
                return [
                    {value: null, text: '-- Select Logic --'},
                    {value: 'Equals', text: '='},
                    {value: 'Is Any', text: 'has any'},
                    {value: 'Is Not Any', text: 'none of'},
                ];
            },

            titleOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Title --'}
                ];

                //Loop
                for(var i = 0; i < this.titles.length; i++)
                {
                    //Push
                    options.push({value: this.titles[i], text: this.titles[i]});
                }

                //Send it
                return options;
            },
        },

        methods: {

            //Load the Account
            getResources(){
                //Send it
                this.$http.get('alerts/recipients/resources', {asset_type: this.assetType})
                    .then(res => {
                        //Set data
                        this.recipientTypes = res.data.recipientTypes;
                        this.roles = res.data.roles;
                        this.titles = res.data.titles;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            addRecipient(){
                //Push it
                this.recipients.push({target_type: null, target_value: null})
            },

            getRecipients(){
                //Send it
                return this.recipients;
            },

            deleteRecipient(key){
                //Splice
                this.recipients.splice(key, 1);
            },

            setErrors(errors){
                //SEt it
                this.errors = errors;
            }
        },

        mounted(){
            //Get the Resources
            this.getResources();

            //Set vars
            this.recipients = this.startingRecipients;
        }
    }
</script>
